export { default } from './Slot'
